import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AddToFavorites, RemoveFromFavorites } from '@app/store';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-is-favorite',
  templateUrl: './is-favorite.component.html',
  styleUrls: ['./is-favorite.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsFavoriteComponent {
  @Input({ required: true })
  linkClass!: string;

  @Input({ required: true })
  imageId!: number;

  @Input({ required: true })
  isFavorite!: boolean;

  constructor(private store: Store) {}

  protected onToggle(): void {
    const toggleAction: AddToFavorites | RemoveFromFavorites = this.isFavorite
      ? new RemoveFromFavorites(this.imageId)
      : new AddToFavorites(this.imageId);

    this.store.dispatch(toggleAction);
  }
}
